<script>
export default {
    name: 'EventItem',

    props: {
        occasion: {
            type: Object,
            required: true
        }
    }
}
</script>

<template>
    <div class="h-100">
        <article class="event-card-calendar d-flex flex-column h-100">
            <a
                :href="occasion.url"
                class="cover-bottom-faded"
            >
                <img
                    :src="occasion.image"
                    :alt="occasion.name"
                    tabindex="-1"
                    aria-hidden="true"
                >
            </a>
            <div class="param">
                <div class="type">
                    <a
                        v-for="(category, idx) in occasion.categories"
                        :key="idx"
                        :href="category.url"
                    >
                        {{ category.name }}
                    </a>
                </div>
                <div
                    v-if="occasion.genres && occasion.genres.length"
                    class="genre"
                >
                    {{ __('Genre') }}:
                    <span
                        v-for="(genre, idx) in occasion.genres"
                        :key="idx"
                    >
                        <a :href="genre.url">{{ genre.name }}<span v-if="idx < occasion.genres.length-1 && occasion.genres.length > 1">,&nbsp;</span></a>
                    </span>
                </div>
            </div>
            <div
                v-if="occasion.series"
                class="mt-2 occasion-series-scoped"
            >
                <div
                    class="series-name"
                >
                    <a
                        :href="occasion.series.url"
                        target="_blank"
                    >
                        {{ occasion.series.name }}
                    </a>
                </div>
            </div>
            <div class="title limit-text-3 labels">
                <span
                    v-if="occasion.isOnline"
                    class="label label-secondary"
                >
                    {{ __('Online') }}
                </span>
                <span
                    v-if="occasion.isPostponed"
                    class="label label-error"
                >
                    {{ __('Postponed') }}
                </span>
                <h3>
                    <a
                        :href="occasion.url"
                        target="_blank"
                    >
                        {{ occasion.name }}
                    </a>
                </h3>
            </div>
            <div class="date-wrap">
                <div class="date">
                    <svg class="icon icon-calendar"><use xlink:href="#icon-calendar" /></svg>
                    <span class="timestamp">{{ occasion.fancyDate }}</span>
                </div>
            </div>
            <div class="mt-auto controls text-right">
                <a
                    :href="occasion.button.url"
                    target="_blank"
                    class="h-auto"
                    :class="[occasion.button.style, { 'disabled': occasion.button.disabled }]"
                    :tabindex="occasion.button.disabled ? -1 : 0"
                >
                    {{ occasion.button.label }}
                </a>

                <a
                    :href="occasion.url"
                    target="_blank"
                    class="btn-more"
                >
                    {{ __('Details') }} <svg class="icon icon-shortarrow"><use xlink:href="#icon-shortarrow" /></svg>
                </a>
            </div>
        </article>
    </div>
</template>

<style scoped lang="scss">
.occasion-series-scoped {
    padding-left: 10px;
    padding-right: 10px;
    padding-bottom: 10px;
    font-size: 12px;

    .series-name {
        padding-left: 6px;
        border-left: 6px solid #0068B1;
    }
}
</style>
